import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicTableComponent } from './basic-table/basic-table.component';
import { UiSwitchModule } from 'ngx-ui-switch'; 
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
  declarations: [
    BasicTableComponent
  ],
  imports: [
    CommonModule,
    NgbTooltipModule,
    MaterialModule,
    UiSwitchModule.forRoot({ size: 'small' })
  ],
  exports: [
    BasicTableComponent
  ]
})
export class DataTableModule { }

